import { render } from "./SubspecialitySelector.vue?vue&type=template&id=4258fbac&scoped=true"
import script from "./SubspecialitySelector.vue?vue&type=script&lang=js"
export * from "./SubspecialitySelector.vue?vue&type=script&lang=js"

import "./SubspecialitySelector.vue?vue&type=style&index=0&id=4258fbac&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4258fbac"]])

export default __exports__